import ChangeTextForm from './ChangeTextForm'

export default ChangeTextForm
